export const CREATE_SKOOTER = 'CREATE_SKOOTER';
export const FETCH_SKOOTERS = 'FETCH_SKOOTERS';
export const FETCH_SKOOTER = 'FETCH_SKOOTER';
export const DELETE_SKOOTER = 'DELETE_SKOOTER';
export const EDIT_SKOOTER = 'EDIT_SKOOTERS';
export const SAVE_ERROR = 'SAVE_ERROR';